import { HttpParams } from '@angular/common/http';

export class AbgangDownloadRequestPojo {
    confirmed = false;
    tierlisten_ids: number[] = [];
    show_barcode: number;
    show_gruppendetails: number;
    show_tiergruppe: number;
    add_scans: number;
    pdf = false;
    csv = false;
    excel = false;
    sortierung: string;
    add_impfstoffe: number;
    zielbetrieb_id: number;
    show_einstalldatum: number;
    show_abteil: number;
    einstalldatum_sort: string;
    geschlecht_sort = 'none';
    split_geschlecht = false;

    constructor(
        tierlisten_ids: number[],
        show_barcode: number,
        show_gruppendetails: number,
        show_tiergruppe: number,
        add_scans: number,
        add_impfstoffe: number,
        show_einstalldatum: number = 0,
        einstalldatum_sort: string = 'none',
        show_abteil: number = 0,
    ) {
        this.confirmed = true;
        this.tierlisten_ids = tierlisten_ids;
        this.show_barcode = show_barcode;
        this.show_gruppendetails = show_gruppendetails;
        this.show_tiergruppe = show_tiergruppe;
        this.add_scans = add_scans;
        this.add_impfstoffe = add_impfstoffe;
        this.show_einstalldatum = show_einstalldatum;
        this.einstalldatum_sort = einstalldatum_sort;
        this.show_abteil = show_abteil;
    }

    getHttpParams(): HttpParams {
        let params = new HttpParams();
        params = params.append('show_tiergruppe', Number(this.show_tiergruppe) > 0 ? '1' : '0');
        params = params.append('show_barcode', Number(this.show_barcode) > 0 ? '1' : '0');
        params = params.append('show_gruppendetails', Number(this.show_gruppendetails) > 0 ? '1' : '0');
        params = params.append('add_scans', Number(this.add_scans) > 0 ? '1' : '0');
        params = params.append('add_impfstoffe', Number(this.add_impfstoffe) > 0 ? '1' : '0');
        params = params.append('show_einstalldatum', Number(this.show_einstalldatum) > 0 ? '1' : '0');
        params = params.append('show_abteil', Number(this.show_abteil) > 0 ? '1' : '0');
        if (this.einstalldatum_sort) {
            params = params.append('einstalldatum_sort', this.einstalldatum_sort);
        }
        if (this.geschlecht_sort && this.geschlecht_sort !== 'none') {
            params = params.append('geschlecht_sort', this.geschlecht_sort);
        }
        params = params.append('split_geschlecht', this.split_geschlecht ? '1' : '0');

        for (const tierliste_id of this.tierlisten_ids) {
            params = params.append('tierliste_id[]', tierliste_id?.toString());
        }
        params = params.append('csv', this.csv ? '1' : '0');
        params = params.append('excel', this.excel ? '1' : '0');
        params = params.append('pdf', this.pdf ? '1' : '0');
        if (this.sortierung) {
            params = params.append('orderby', this.sortierung);
        }
        if (this.zielbetrieb_id) {
            params = params.append('zielbetrieb_id', this.zielbetrieb_id.toString());
        }
        return params;
    }

    pdfDownloadVerfuegbar() {
        if (this.split_geschlecht) {
            return false;
        }
        if (this.tierlisten_ids?.length == 1 && this.pdf === true && this.csv === false && this.excel === false) {
            return true;
        }
        return false;
    }

    csvDownloadVerfuegbar() {
        if (this.tierlisten_ids?.length == 1 && this.csv === true && this.pdf === false && this.excel === false) {
            return true;
        }
        return false;
    }

    excelDownloadVerfuegbar() {
        if (this.tierlisten_ids?.length == 1 && this.excel === true && this.pdf === false && this.csv === false) {
            return true;
        }
        return false;
    }
}
